import { useState } from 'react';
import { S3Image } from '../S3Image';
import { cn } from '../../lib/utils';

interface AppIconProps {
  iconUrl?: string | null;
  thumbnailUrl?: string | null;
  name: string;
  /** Square size in px (Figma uses 20 / 32 / 40 / 96). */
  size?: number;
  className?: string;
}

/** Squircle-ish app icon with an initial-letter fallback. */
export function AppIcon({
  iconUrl,
  thumbnailUrl,
  name,
  size = 40,
  className,
}: AppIconProps) {
  // Fade the bitmap in once it has loaded; a new URL fades in again.
  const [loadedUrl, setLoadedUrl] = useState<string | null>(null);
  return (
    <div
      aria-hidden="true"
      style={{ width: size, height: size }}
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-[22%] bg-seeker-800 text-seeker-400 shadow-[inset_0_0.375px_0.375px_0_rgba(255,255,255,0.17)]',
        className,
      )}
    >
      {iconUrl ? (
        <S3Image
          src={iconUrl}
          thumbnailSrc={thumbnailUrl}
          useThumbnail={size <= 40}
          alt=""
          width={size}
          height={size}
          onLoad={() => setLoadedUrl(iconUrl)}
          className={cn(
            'size-full object-cover transition-opacity duration-200 ease-out',
            loadedUrl === iconUrl ? 'opacity-100' : 'opacity-0',
          )}
        />
      ) : (
        <span
          className="font-bold uppercase leading-none"
          style={{ fontSize: Math.max(10, Math.round(size * 0.4)) }}
        >
          {name.trim().charAt(0) || '?'}
        </span>
      )}
    </div>
  );
}
